import React, {Component}  from 'react';
import nest from './nestExpand'

class SelectWrapper extends Component {

  constructor(){
    super()
    this.state={
      expanded:{},
      searchTerms:{} // {sectionname: searchterm}
    }
    this.expand = this.expand.bind(this)
    this.changeSearchTerm = this.changeSearchTerm.bind(this)
  }

  expand(v, parents){
    this.setState({expanded: nest.expand(v, parents, this.state.expanded)})
  }

  changeSearchTerm(v, section){
    const searchTerms = {...this.state.searchTerms}
    searchTerms[section] = v
    this.setState({searchTerms})
  }

  render(){
    const { values, inputs, selectedValues, sectionLabels, sectionTypes, fieldPropLabel, fieldPropType, showApiNames } = this.props

    const {searchTerms} = this.state
    const iterator = function(sectionValues, entity, sectionLabel, iteration, parents, newParent, sectionType){
      if(newParent){
        parents = parents.concat(newParent)
      }

      let title = ''
      parents && parents.forEach(pt=>{
        title += pt
        title += ': '
      })
      // CHOOSE HERE TYPE OR LABEL
      title += entity[showApiNames&&fieldPropType ? fieldPropType : fieldPropLabel]

      // ADD REQUIRED
      if(entity.required){
        title += ' *'
      }

      const isExpanded = nest.checkIfExpanded(entity[fieldPropLabel], parents, this.state.expanded)
      let isSelected = false
      isSelected = selectedValues && selectedValues.length>0 && selectedValues
        .some(rsc=>{
          return rsc[fieldPropLabel]===entity[fieldPropLabel] &&
          (!(parents&&rsc.parents)||JSON.stringify(rsc.parents)===JSON.stringify(parents)) &&
          (!rsc.section||sectionLabel===rsc.section)
        })

      sectionValues.push({
        ...entity,
        title,
        section: sectionLabel,
        __section: sectionType,
        iteration,
        parents,
        isExpanded,
        isSelected,
      })

      if(entity.object && isExpanded){
        entity.object.properties.forEach(p=>{
          iterator(sectionValues, p, sectionLabel, iteration+1, parents, entity[fieldPropLabel], sectionType)
        })
      }
      return sectionValues
    }.bind(this)

    var vals = values && [ ...values ]

    if(sectionLabels){
      var v = []
      sectionLabels.forEach((s,i)=>{
        if(values && values[i] && values[i].length>0){
          // ADD TITLE OF SECTION HERE
          v = v.concat(showApiNames&&sectionTypes ? sectionTypes[i] : sectionLabels[i])
          let sectionValues = []
          values[i].forEach(entity=>{
            const sectionType = sectionTypes && sectionTypes[i]
            iterator(sectionValues, entity, sectionLabels[i], 0, [], null, sectionType)
          })
          //search
          sectionValues.forEach((sv,ii)=>{
            let satisfiesSearch = true // default show everything
            if(searchTerms && searchTerms[sectionLabels[i]]){
              satisfiesSearch = sv[showApiNames ? fieldPropType : fieldPropLabel]
                .toLowerCase().indexOf(searchTerms[sectionLabels[i]].toLowerCase()) 
              > -1
            }
            sv.satisfiesSearch = satisfiesSearch
            //satisfy parents
            if(searchTerms && satisfiesSearch){
              // for nested resources (parentRef)
              if(sv.parentRef){
                sv.parentRef.forEach((pr)=>{
                  const parentString = pr.ref.split('/')[2]
                  const parent = sectionValues.find((p)=>{
                    return parentString === p[fieldPropLabel]
                  })
                  if(parent){
                    parent.satisfiesSearch = true
                  }
                })
              }
              // for nested props (parents array)
              if(sv.parents){
                sv.parents.forEach((pr)=>{
                  const parent = sectionValues.find((p)=>{
                    return pr === p[fieldPropLabel]
                  })
                  if(parent){
                    parent.satisfiesSearch = true
                  }
                })
              }
            }
          })
          v = v.concat(sectionValues)
        }
      })
      vals = v
    } else {
      let sectionValues = []
      values && values.forEach(entity=>{
        iterator(sectionValues, entity, '', 0, [])
      })
      sectionValues.forEach((sv)=>{
        sv.satisfiesSearch = true // no sections = no search
      })
      vals = sectionValues
    }

    return (
      <div style={{display:'inline-block'}}> 
        <inputs.Select {...this.props} vals={vals} expand={this.expand} 
          changeSearchTerm={this.changeSearchTerm} />
      </div>
    ) 
  }
}

export default SelectWrapper





// WEBPACK FOOTER //
// ./src/lib/wizard/stepTypes/utils/selectWrapper.js